// 引入 axios
import axios from "axios";


// #let base = 'https://www.hystagelight.com/portal_server';
let base = '/portal_server';
// let base = 'https://test.com:32660/portal_server';

// 保证跨域请求时携带 Cookie（Session 方案所需）
axios.defaults.withCredentials = true;

// ========== 拦截器 ==========
axios.interceptors.request.use(config => config, error => Promise.reject(error));

// 401 跳转后台登录
axios.interceptors.response.use(resp => resp, error => {
    if (error.response && error.response.status === 401) {
        const hash = window.location.hash || '';
        if (hash.indexOf('/admin') !== -1 && hash.indexOf('/admin/login') === -1) {
            window.location.href = '#/admin/login';
        }
    }
    return Promise.reject(error);
});

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        data: params,
    })
}

// 传送 json 格式的 post 请求
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params, // POST 请求使用 data 传递数据
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 传送 multipart/form-data 的 post 请求（文件上传）
export const postFormDataRequest = (url, formData) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// put 请求（JSON）
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// put 请求（multipart/form-data，含文件上传）
export const putFormDataRequest = (url, formData) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// delete 请求
export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        data: params,
    });
};
